(ns practitest.frontend.components2.dashboard.transforms.bar
  (:require [practitest.frontend.components2.dashboard.schema :as sc]
            [practitest.frontend.components2.dashboard.helpers :as h]))

(def BarItem
  [:map
   [:category :string]
   [:group :string]
   [:value number?]])

(def BarSeriesData
  [:map
   [:chart/data [:vector BarItem]]
   [:chart/inactive-groups [:vector [:string]]]
   [:chart/categories [:vector [:string]]]
   [:chart/series [:vector [:string]]]])

(defn base-transform
  "Flattens series/categories into flat {:category :group :value} rows."
  {:malli/schema [:=> [:cat [:map
                             [:chart/data sc/SeriesCategories]
                             [:chart/cell-width {:optional true} [:maybe [:enum :regular :double]]]]]
                  BarSeriesData]}
  [{{:keys [series categories]} :chart/data
    :chart/keys                 [toggle-legend]
    :or                         {toggle-legend {}}
    :as                         chart}]
  (let [active?              #(toggle-legend % true)
        a-series             (h/active-series series active?)
        categories-count     (count categories)
        inactive-groups      (->> series
                                  (remove #(some #{(:name %)} (map :name a-series)))
                                  (mapv :name))]

    (merge chart
           {:chart/data
            (vec
             (mapcat (fn [idx category]
                       (map (fn [{group :name data :data}]
                              {:category category
                               :group    group
                               :value    (nth data idx 0)})
                            a-series))
                     (range categories-count)
                     categories))

            :chart/inactive-groups inactive-groups
            :chart/categories      categories
            :chart/series          (mapv :name series)})))

(defn transform
  [{:chart/keys [x-values-map y-values-map] :as chart}]
  (let [base (base-transform chart)]
    (update base :chart/data
            (fn [items]
              (mapv (fn [{:keys [category group] :as item}]
                      (assoc item :url-params
                             {:x-param (get x-values-map (keyword category) category)
                              :y-param (get y-values-map (keyword group) group)}))
                    items)))))
